import { GetWireTransferSetupResponse } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import { Typography } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Display a bank account description suitable for display
 *
 * @param prop               Props
 * @param prop.meanOfPayment corresponding row
 *
 * @returns                  BankAccountDescription component
 */
export const BankAccountDescription = ({
  meanOfPayment,
}: {
  meanOfPayment: GetWireTransferSetupResponse;
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction={'row'}
      sx={{ height: '100%', alignItems: 'center' }}
    >
      <Typography variant={'body2'}>
        {t('ik.invoice.select.paymentMethod.sepa')}
      </Typography>
      <Typography variant={'body2'}>
        {meanOfPayment.sepaDebitCountryCode}{' '}
      </Typography>
      <Typography variant={'body2'}>{meanOfPayment.sepaDebitLast4} </Typography>
    </Stack>
  );
};
